<template>
  <div class="gray11 px-2 pt-4 rounded-lg" style="height: 34rem;overflow: auto">
    <v-data-table
      class="custom-reward-data-table"
      :headers="headers"
      :items="state.detailContents.rewards"
      hide-default-footer
      fixed-header
      ref="table"
      :header-props="{ 'sort-icon': '$sortIcon' }"
      :no-data-text="$t('common.nodata')"
    >
      <template v-slot:item.start="{ item }">
        <span v-if="item.end" class="font-Regular-14"
          >{{ item.start | formatDate }} {{ $t("common.until") }}
          {{ item.end | formatDate }}</span
        >
        <span class="font-Regular-14" v-else
          >{{ item.start | formatDate }}
        </span>
      </template>
      <template v-slot:item.activeAPY="{ item }">
        <span class="font-Regular-14">%{{ item.activeAPY }}</span>
      </template>
      <template v-slot:item.rewardAmount="{ item }">
        <div class="font-Regular-14">
          <span>{{
            $thousandMask(item.rewardAmount, headerData.rewardScale)
          }}</span
          ><span class="me-1">{{ headerData.coinUnit }}</span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import $thousandMask from "@/mixins/thousandMask";
export default {
  inject: ["state"],
  props: ["headerData"],
  mixins: [$thousandMask],
  data() {
    return {
      headers: [
        {
          text: this.$t("staking.stakingPlans.dialogDetail.rewardTable.Date"),
          value: "start",
          align: "center",
          width: "43%"
        },
        {
          text: this.$t(
            "staking.stakingPlans.dialogDetail.rewardTable.Reward_Percentage"
          ),
          value: "activeAPY",
          align: "center",
          sortable: false
        },
        {
          text: this.$t(
            "staking.stakingPlans.dialogDetail.rewardTable.Daily_Received_Amount"
          ),
          value: "rewardAmount",
          align: "center",
          sortable: false
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.custom-reward-data-table {
  thead {
    th {
      border-radius: 0 !important;
      background-color: var(--v-gray10-base) !important;
      color: var(--v-gray2-base) !important;
      border-bottom: 2px solid rgba(0, 0, 0, 0.04) !important;
      width: 150px;
      //border-top: 1px solid rgba(118, 131, 145, 0.2) !important;
    }
  }

  tbody {
    tr {
      cursor: unset;
      height: 68px;
      &.v-data-table__empty-wrapper {
        height: 380px;
        span {
          color: var(--v-gray1-base) !important;
        }
      }

      background-color: var(--v-gray11-base) !important;
      &.v-data-table__selected {
        background: unset !important;
      }
      td {
        color: var(--v-gray1-base);
        border-bottom: 1px solid var(--v-gray7-base) !important;
        border-top: 1px solid var(--v-gray7-base) !important;
        &:first-of-type,
        &:last-of-type {
          border-radius: 0 !important;
        }
      }
      &:last-child td {
        border-bottom: 0 solid white !important;
      }
      &:first-child td {
        border-top: 0 solid white !important;
      }

      .custom-action-button {
        color: var(--v-primary-base) !important;

        .v-btn__content {
          font-family: IRANSansMedium, "sans-serif";
        }
      }

      .display-favorite-checkbox {
        display: flex !important;
        justify-content: center;
        .favorite-checkbox {
          opacity: 0;
          position: absolute;
        }
      }

      .svg-color-secondary {
        path:last-child {
          fill: var(--v-secondary-base);
          stroke: var(--v-secondary-base);
        }
      }

      .display-row-number {
        display: inline-block;
        color: var(--v-gray1-base);
      }

      //&:hover {
      //  background-color: var(--v-lighter-base) !important;
      //}
    }
  }

  .v-data-table__mobile-row:last-child .v-data-table__mobile-row__cell {
    width: 100%;
  }
}

@media (max-width: 800px) {
  thead {
    display: none;
  }
  tbody {
    tr:nth-child(even) {
      td {
        background-color: var(--v-lighter-base) !important;
      }
    }
  }
}
</style>
